import { useTranslation } from 'react-i18next';
import { LightPinIcon, PinLabel } from './pinned-label.styled';
import { FlexContainer } from '../../../common/flex-container/flex-container.styles';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../../common/tooltip/tooltip.component';

interface Props {
  onlyIcon?: boolean;
}

const PinnedLabelComponent = ({ onlyIcon }: Props) => {
  const { t } = useTranslation();
  return (
    <FlexContainer>
      <Tooltip placement='bottom'>
        <TooltipTrigger asChild>
          <LightPinIcon />
          {!onlyIcon && <PinLabel>{t('home_filter_pinned')}</PinLabel>}
        </TooltipTrigger>
        <TooltipContent>{t('pinned_parcel')}</TooltipContent>
      </Tooltip>
    </FlexContainer>
  );
};

export default PinnedLabelComponent;
